export const DeliveryAreaRestrictionEnum = {
    Disabled: "disabled",
    Distance: "distance",
    ZipCodes: "zipCodes",
}

export type DeliveryAreaRestrictionType = (typeof DeliveryAreaRestrictionEnum)[keyof typeof DeliveryAreaRestrictionEnum]

export const MiBOrderingModeEnum = {
    Delivery: "delivery",
    Epurchase: "epurchase",
    DineIn: "dinein",
}

export type MiBOrderingModeType = (typeof MiBOrderingModeEnum)[keyof typeof MiBOrderingModeEnum]
